module.exports = __webpack_public_path__ + "static/media/laptop.72cfb141.png";